export default __webpack_public_path__ + "static/media/870-min.cb702bed.png";